'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverCarouselCard", {
    enumerable: true,
    get: function() {
        return TeachingPopoverCarouselCard;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverCarouselCard = require("./useTeachingPopoverCarouselCard");
const _renderTeachingPopoverCarouselCard = require("./renderTeachingPopoverCarouselCard");
const _useTeachingPopoverCarouselCardStylesstyles = require("./useTeachingPopoverCarouselCardStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TeachingPopoverCarouselCard = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverCarouselCard.useTeachingPopoverCarouselCard_unstable)(props, ref);
    (0, _useTeachingPopoverCarouselCardStylesstyles.useTeachingPopoverCarouselCardStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTeachingPopoverCarouselCardStyles_unstable')(state);
    return (0, _renderTeachingPopoverCarouselCard.renderTeachingPopoverCarouselCard_unstable)(state);
});
TeachingPopoverCarouselCard.displayName = 'TeachingPopoverCarouselCard';
